import React from 'react';
import { Flex } from "antd";
import arrowUp from "images/arrow-up-red.svg";
import arrowDown from "images/arrow-down-green.svg";
import importIcon from "images/import.svg";
import exportIcon from "images/export.svg";
import "styles/imageStyles.css";

interface DirectionIconProps {
  direction: 'IMP' | 'EXP';
}

const typeIcon = {
  IMP: arrowDown,
  EXP: arrowUp,
};

export const DirectionIcon: React.FC<DirectionIconProps> = React.memo(({ direction }) => {
  return (
    <Flex vertical gap={4} className="square icon-3xl bg-basic-200">
        <img src={typeIcon[direction]} alt={direction} />
        <img src={direction === 'IMP' ? importIcon : exportIcon} alt={""} />
    </Flex>
  );
});
